module.exports = __webpack_public_path__ + "img/phone.15119037.svg";